import React from "react";
import { LoginMat, LoginInner, FooterCreds } from "./styled";
import AdminLogo from "components/img/AdminLogo";

const LoginCard = ({
  children,
  header,
  footer
}: any) =>{


  return (
    <LoginMat>
      <AdminLogo alt={process.env.REACT_APP_SERVICE} customStyles={{width: "250px", margin: "auto"}}/> 
      <LoginInner>
        {children}
      </LoginInner>                    
      <FooterCreds>© {process.env.REACT_APP_SERVICE}, 2025 & beyond. All Rights Reserved</FooterCreds>   
    </LoginMat>
  )
}

export default LoginCard;